export default "__VITE_ASSET__CUwdSQ4Z__"